<div class="tableTitle">
  <p class="h1">Tabela de <strong>preços</strong></p>
  <p class="h2">
    Consulte a tabela abaixo para entender o valor de cada consulta e quantas
    soluções você poderá utilizar.
  </p>
</div>
<div class="table">
  <div class="features">
    <div class="featureItem header"></div>
    <div class="featureItem" *ngFor="let item of featureItems">
      <div class="name">{{ item }}</div>
    </div>
  </div>

  <pme-carousel-swiper [items]="shopWindowItems" [identifier]="'shop-window-products-table'">
    <ng-template let-plan let-i="index">
      <div class="product">
        <div class="productName">Pacote R${{ plan.baseValueStr }}</div>
        <div class="featureValue" *ngFor="let feature of plan.featureList">
          <div class="value">
            {{ !feature.toValue ? "-" : feature.toValue }}/un
          </div>
        </div>
        <div class="btn">
          <button class="buy" (click)="onBuyClicked(i)">Comprar</button>
        </div>
      </div>
    </ng-template>
  </pme-carousel-swiper>
</div>